import AddCalendarSystem from "../../Components/Modals/AddCalendarSystem";
import Table from "../../Components/Table";
import { deleteCalendarById, getCalendars } from "../../Services/MasterService";

const CalendarSystem = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    },
    {
      label: "Value",
      value: "value"
    },
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddCalendarSystem data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getCalendars}
      columns={columns}
      title={"Calendar System"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteCalendarById}
    />
  );
}

export default CalendarSystem;